<section class="section more-proyects" id='more-proyects'>
    <div class="container">
        <div class="section-box">
            <div data-aos="fade-up" data-aos-duration="1000">
                <h3 class="section-title">
                    <span class='n-section-title'>04.</span> Estudios
                </h3>
            
                <div id="estudio" class="col-6 col-md-6" *ngFor="let estudio of AboutEstudios">
                    {{estudio?.estudio}}
                  </div>
                  <button class="boton_editar" (click)="goToHabilidad()">
                    <img class="boton_editar" src="/assets/images/boton_editar_3.png"/>
                    </button>
            </div>
        </div>
    </div>
</section>
